import { z } from 'zod';
export const budgetImportMappingSchema = z.object({
    sourceTempoAccountKey: z.string().trim().min(1).max(128),
    projectId: z.uuid(),
});
export const budgetImportExclusionSchema = z.object({
    sourceTempoAccountKey: z.string().trim().min(1).max(128),
    reason: z.string().trim().min(1).max(500),
});
export const budgetImportInputSchema = z.object({
    sourceLabel: z.string().trim().min(1).max(240),
    csv: z.string().min(1).max(2_000_000),
    mappings: z.array(budgetImportMappingSchema).max(100).default([]),
    exclusions: z.array(budgetImportExclusionSchema).max(100).default([]),
});
export const budgetImportIssueSchema = z.object({
    row: z.number().int().positive(),
    code: z.string().min(1).max(128),
    field: z.string().min(1).max(240).nullable(),
    sourceTempoAccountKey: z.string().max(128).nullable(),
});
export const budgetImportAcceptedSchema = z.object({
    row: z.number().int().positive(),
    projectId: z.uuid(),
    projectName: z.string(),
    sourceTempoAccountKey: z.string(),
    envelopeName: z.string(),
    sourceExternalId: z.string(),
    budgetAmountMinor: z.number().int().nonnegative(),
    depositAmountMinor: z.number().int().nonnegative(),
    depositAppliedMinor: z.number().int().nonnegative(),
    currency: z.enum(['CAD', 'USD']),
});
export const budgetImportSummarySchema = z.object({
    created: z.number().int().nonnegative(),
    updated: z.number().int().nonnegative(),
    unchanged: z.number().int().nonnegative(),
    archived: z.number().int().nonnegative(),
});
export const budgetImportPreviewSchema = z.object({
    accepted: z.array(budgetImportAcceptedSchema),
    issues: z.array(budgetImportIssueSchema),
    requiredTempoAccountKeys: z.array(z.string()),
    excludedTempoAccountKeys: z.array(z.string()),
    mappingsToPersist: z.array(budgetImportMappingSchema),
    summary: budgetImportSummarySchema,
    confirmable: z.boolean(),
});
export const budgetImportRunSchema = z.object({
    id: z.uuid(),
    sourceLabel: z.string(),
    status: z.enum(['previewed', 'confirmed', 'rejected']),
    acceptedCount: z.number().int().nonnegative(),
    rejectedCount: z.number().int().nonnegative(),
    preview: budgetImportPreviewSchema,
    confirmedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
//# sourceMappingURL=budget-imports.js.map